import { MDCLineRipple } from '@material/line-ripple';
import { h } from 'preact';
import MaterialComponent from '../Base/MaterialComponent';
export class LineRipple extends MaterialComponent {
    constructor() {
        super(...arguments);
        this.componentName = 'line-ripple';
        this.mdcProps = [];
    }
    componentDidMount() {
        super.componentDidMount();
        if (this.control) {
            this.MDComponent = new MDCLineRipple(this.control);
        }
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.MDComponent) {
            this.MDComponent.destroy();
        }
    }
    materialDom(props) {
        return h("div", Object.assign({}, props, { ref: this.setControlRef }));
    }
}
export default LineRipple;
//# sourceMappingURL=index.js.map